import axios  from "axios"

export default {
    state: {
    },
    mutations: {
    },
    actions: {
        createTask(context, payLoad) {
            return axios.post('action-list/task', payLoad)
            .then(({data}) => data)
            .catch(err => err.response)
        },

        getDailyTasks(context, payLoad, status = 'active') {
            const { sortBy, sortDesc, page, itemsPerPage } = payLoad
            var url = `action-list/task?page=${page}&limit=${itemsPerPage}`;
            if(sortBy.length === 1 && sortDesc.length === 1)
                url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`
            
            url = `${url}&status=${status}`
            return axios.get(url)
            .then(({data}) => data)
            .catch(err => err.response);
        },
        getSingleTaskDetails(context, taskNum) {
            var url = `action-list/task/${taskNum}`
            return axios.get(url)
            .then(({data}) => data)
            .catch(err => err.response);
        },
        getTasksBetweenDates(context, payLoad) {
            var url = `action-list/event?sDate=${payLoad.startDate}&eDate=${payLoad.endDate}`
            return axios.get(url)
            .then(({data}) => data)
            .catch(err => err.response);
        },
        registerhealthRecord(context, payload){
            return axios.put('action-list/task/health-record', payload)
            .then(({data}) => data)
            .catch(err => err.response)
        },
        registerRecord(context, payload){
            return axios.post('action-list/task/insemination', payload)
            .then(({data}) => data)
            .catch(err => err.response)
        },
        updateTask(context, payload){
            return axios.put('action-list/task', payload)
            .then(({data}) => data)
            .catch(err => err.response)
        },
        deleteRecord(context, taskNum){
            var url = `action-list/task/${taskNum}`
            return axios.delete(url)
        .then((result) => result.data)
        
        .catch( error => Promise.reject(error));
        }
    },
    getters: {
    },
    modules: {
      
    }
}